import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portada-layout',
  templateUrl: './portada-layout.component.html',
  styleUrls: ['./portada-layout.component.scss']
})
export class PortadaLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
